<template>
    <div class="main-content">
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg-ser">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Services</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white">
                                                <i class="mdi mdi-home theme-light-color pr-2"></i>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li class="theme-light-color active">Services</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Services Top Area -->
        <!-- <section class="section services-inner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="section-title">
                            <span>100 + YEARS OF EXPERIENCE</span>
                            <h2>I4NI's Services</h2>
                        </div>
                        <div id="progress-bar" class="progress-bar-block">

                            <div id="bar-1" class="bar-main-container azure">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Research and Development</label>
                                    <div class="bar-percentage" data-percentage="46"></div>
                                </div>
                            </div>

                            <div id="bar-2" class="bar-main-container emerald">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Workforce Development</label>
                                    <div class="bar-percentage" data-percentage="94"></div>
                                </div>
                            </div>

                            <div id="bar-3" class="bar-main-container violet">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Business Development</label>
                                    <div class="bar-percentage" data-percentage="47"></div>
                                </div>
                            </div>

                            <div id="bar-4" class="bar-main-container yellow">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Commercialization</label>
                                    <div class="bar-percentage" data-percentage="85"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="mt-lg-0 mt-5">
                            <img src="../assets/images/images/Incidence_Response.png" alt="" class="img-fluid w-100 ">
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- End Services Top Area -->
        <!-- Start Services Area -->
		<section class="section services-inner">
		  <div class="container">
			<div class="section-title text-center z-index9">
                    <h2 style="text-align:center;">Focused on Meeting the Needs of our Customers and Members​</h2>
					<p>
						I4NI’s portfolio of services has been designed specifically to generate new ideas, nurture talent, and find novel applications of technology in support of the defense and national security communities. This prioritization structure allows us to maintain a pool of innovators with the capability, capacity, quality, and readiness to describe, develop, and demonstrate prototypes (physical, digital, conceptual, or analytical) that resolve our nation’s security and defense challenges. 
					</p>
                </div>
			</div>
		</section>
        <section class="section parallax-bg" id="services">
            <div class="container">
                <!-- <div class="section-title text-center z-index9">
                    <h2 class="text-white">I4NI Services focused on our Customer and Member needs​</h2>
					<p class="text-white">
						The I4NI portfolio of services is designed to generate new ideas, nurture talent, and find novel applications of technology in support of the Department and the national security community​ writ large. By prioritizing this structure, we will maintain a pool of innovators with the capability, capacity, quality, and readiness to describe, develop and demonstrate prototypes (e.g., physical,​ digital, conceptual, or analytical) that resolve national security challenges.
					</p>
                </div> -->
                <div class="service-boxes-area">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.2s" data-wow-duration="1s" style="height:450px">
                                <div class="icon">
                                    <!-- <i class="mdi mdi-desktop-mac-dashboard"></i> -->
									<img src="../assets/images/icons/projectplanning.svg" alt="">
                                </div>
                                <h3>Project Planning and Acquisition Strategy​</h3>
								<ul text:align="left">
									<li>Strategy Development</li>
									<li>Project Planning</li>
									<li>Government Resource Coordination</li>
									<li>Technical Expertise Gap Filling</li>
								</ul>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.4s" data-wow-duration="1s" style="height:460px">
                                <div class="icon">
                                    <!-- <i class="mdi mdi-responsive"></i> -->
									<img src="../assets/images/icons/solicitation.svg" alt="">
                                </div>
                                <h3>Solicitation Management</h3>
								<ul>
									<li>Strategic Communication</li>
									<li>Web-portal Development</li>
									<li>Standardized Solicitation Issuance</li>
									<li>Response Evaluation</li>
									<li>Selection Coordination</li>
								</ul>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.6s" data-wow-duration="1s" style="height:460px">
                                <div class="icon">
                                   <!--  <i class="mdi mdi-rocket"></i> -->
								   <img src="../assets/images/icons/barrierremoval.svg" alt="">
                                </div>
                                <h3>Barrier Reduction and Removal</h3>
								<ul>
									<li>Exchange Hosting</li>
									<li>Technical Challenge and Concern Collection and Distribution</li>
									<li>Communication Outreach</li>
									<li>Industry Understanding Assessment and Reporting</li>
								</ul>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.8s" data-wow-duration="1s" style="height:460px">
                                <div class="icon">
                                    <!-- <i class="mdi mdi-chat-processing-outline"></i> -->
									<img src="../assets/images/icons/mentoring.svg" alt="">
                                </div>
                                <h3>Small Business Mentoring</h3>
								<ul>
									<li>Existing Program Identification and Utilization </li>
									<li>Solicitation Response Assistance</li>
									<ul>
										<li>Preparation</li>
										<li>Compliance Pricing</li>
										<li>Data Rights</li>
									</ul>
									<li>
										Subject Matter Expertise
										<ul>
											<li>Cybersecurity</li>
											<li>Export Control</li>
											<li>Compliance Monitoring and Mitigation</li>
										</ul>
									​</li>
								</ul>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="1s" data-wow-duration="1s" style="height:460px">
                                <div class="icon">
                                    <!-- <i class="mdi mdi-chart-bar"></i> -->
									<img src="../assets/images/icons/training.svg" alt="">
                                </div>
                                <h3>Tailored Training​</h3>
								<ul>
									<li>Comprehensive Guidance and Education </li>
									<li>Integration Acceleration </li>
									<li>Manufacturing Process Planning </li>
								</ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Services Area -->
        <!-- Start Services Bottom Area -->
        <!-- <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div>
                            <img src="../assets/images/images/Circuit Board_lg.jpeg" alt="" class="img-fluid w-100">
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="services-info-box">
                            <div class="section-title">
                                <h2 class="title position-relative pb-2 mb-3">Other Services</h2>
                            </div>
                            <ul class="list-unstyled mb-0">
                                <li>
                                    <a href="#" class="text-dark">
                                        Compliance
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="text-dark">
                                        Systems Development
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="text-dark">
                                        Advisory Services
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="text-dark">
                                        Analytics/Machine Learning
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-4 text-lg-left text-center">
                            <h2>An Institute for Nascent Innovation</h2>
                            <p>
								I4NI through its partners will facilitate project teaming, collaborative research, development, and commercialization to enhance both warfighter advantage and U.S. economic competitiveness.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- End Services Bottom Area -->
    </div>
</template>
<script>
    export default {
        name: 'services',
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initFooterHeight();
                this.initPogressBar();
            },
            initFooterHeight() {
                var footerHeight = $("footer").outerHeight();
                $('.main-content').css('margin-bottom', footerHeight);
            },
            initPogressBar() {
                $('.bar-percentage[data-percentage]').each(function () {
                    var progress = $(this);
                    var percentage = Math.ceil($(this).attr('data-percentage'));
                    $({ countNum: 0 }).animate({ countNum: percentage }, {
                        duration: 2000,
                        easing: 'linear',
                        step: function () {
                            // What todo on every count
                            var pct = Math.floor(this.countNum) + '%';
                            progress.text(pct) && progress.siblings().children().css('width', pct);
                        }
                    });
                });
            }
        }
    }
</script>
<style scoped>
ul {
	text-align: left;
}
</style>